/**
 * TODO: Rename to `react-utils`
 * TODO: move to frontend package
 */
import { type ClassValue, clsx } from 'clsx';
import type React from 'react';
import { type Context, use } from 'react';
import { twMerge } from 'tailwind-merge';

export const useContextAndErrorIfNull = <T>(context: Context<T | null>): T => {
  const contextValue = use(context);
  if (contextValue === null) {
    throw new Error('Context has not been Provided!');
  }
  return contextValue;
};

export function cn(...inputs: Array<ClassValue>) {
  return twMerge(clsx(inputs));
}

export type ComponentWithClassName = React.ComponentType<{
  className?: string;
}>;
